import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { getContrastYIQ } from '../get-contrast';
var clampRamp = function clampRamp(n) {
  var v = Math.max(100, Math.min(1000, n));
  return v;
};
var buildRampMap = function buildRampMap(r) {
  return new Map([[100, r.color100], [200, r.color200], [300, r.color300], [400, r.color400], [500, r.color500], [600, r.color600], [700, r.color700], [800, r.color800], [900, r.color900], [1000, r.color1000]]);
};
var textOn = function textOn(hex) {
  return getContrastYIQ(hex) === 'dark' ? '#FFFFFF' : '#000000';
};

/**
 * Derives brand background and text colors (default, hover, active) from a generated color ramp.
 *
 * How it works:
 * - Base ramp: Finds the exact ramp step (100–1000) whose hex equals the provided primaryColor.
 * - Interaction ramps:
 *   - If base >= 800 (very dark end), move lighter for better contrast:
 *     - hover = base - 200
 *     - active = base - 300
 *   - Otherwise, move darker:
 *     - hover = base + 200
 *     - active = base + 300
 *   - All ramp values are clamped to [100, 1000].
 * - Text colors: For each background (base/hover/active), uses YIQ contrast to choose
 *   '#FFFFFF' on dark backgrounds and '#000000' on light backgrounds.
 *
 *
 * @param ramps - The color ramps to use.
 * @param primaryColor - The primary color to derive from (guaranteed to be present in ramps).
 * @returns The derived brand colors, including brand, hover, active, brandText, hoverText, and activeText.
 */
export var deriveBrandColors = function deriveBrandColors(ramps, primaryColor) {
  var rampMap = buildRampMap(ramps);
  var target = primaryColor.toLowerCase();
  var baseRamp = 400;
  var _iterator = _createForOfIteratorHelper(rampMap),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        n = _step$value[0],
        hex = _step$value[1];
      if (hex.toLowerCase() === target) {
        baseRamp = n;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var goLighter = baseRamp >= 800;
  var hoverRamp = clampRamp(baseRamp + (goLighter ? -200 : 200));
  var activeRamp = clampRamp(baseRamp + (goLighter ? -300 : 300));
  var brand = rampMap.get(baseRamp);
  var hover = rampMap.get(hoverRamp);
  var active = rampMap.get(activeRamp);
  return {
    brand: brand,
    hover: hover,
    active: active,
    brandText: textOn(brand),
    hoverText: textOn(hover),
    activeText: textOn(active)
  };
};